<template>
  <div ref="actionBar" class="row action-bar my-3 mx-2">
    <div class="btn-toolbar py-3 col-12">
      <b-button-group>
        <b-button
          v-if="!this.saving()"
          @click.prevent="saveChanges"
          class="txt-btn btn-refonte"
          variant="outline-primary"
        >
          <font-awesome-icon :icon="['fas', 'save']" /> Sauvegarder
        </b-button>
        <b-button v-else class="txt-btn" variant="primary">
          <b-spinner small type="grow"></b-spinner> En attente...
        </b-button>
      </b-button-group>
      <b-button-group>
        <b-button @click="handleExport" variant="outline-primary btn-refonte">
          <font-awesome-icon :icon="['fas', 'upload']" /> Exporter
        </b-button>
      </b-button-group>
      <!-- <b-button-group>
        <b-button class="icon-btn" variant="outline-primary" @click="undo">
          <font-awesome-icon :icon="['fas', 'undo']" />
        </b-button>
        <b-button class="icon-btn" variant="outline-primary" @click="redo">
          <font-awesome-icon :icon="['fas', 'redo']" />
        </b-button>
      </b-button-group> -->
      <div class="toolbox-linear d-flex">
        <!-- zoom-menu -->
        <div class="zoom-menu">
          <b-dropdown
            id="zoom"
            text="Zoom"
            class="btn-refonte"
            variant="outline-primary"
            @click="collapse()"
            @toggle="collapse()"
          >
            <b-dropdown-text>
              <div class="wrap-zone">
                <zoom
                  v-if="this.schema.stage"
                  :scale="this.schema.stage.scaleX()"
                  @zoom="handleZoom"
                />
              </div>
            </b-dropdown-text>
          </b-dropdown>
        </div>
        <!-- ./zoom-menu -->
        <!-- wrap-group-action -->
        <div class="wrap-group-action" v-click-outside="handleClickOutside">
          <!-- action-menu -->
          <!-- <div class="action-menu menu-cta-item">
                <b-button class="btn-refonte"
                     @click="collapse()"
                    :variant="isActive(actions.SELECTION) ? 'primary' : 'outline-primary'">
                  <font-awesome-icon :icon="['far', 'hand-pointer']"/>
                </b-button>
              </div> -->
          <!-- ./action-menu -->
          <!-- trait-menu -->
          <div class="trait-menu menu-cta-item">
            <b-button
              variant="outline-primary"
              class="icon-btn collapsed addon-btn"
              @click="collapse('traitChoice')"
            >
              <div class="icon-wrapper">
                <!-- liste icone selon choix -->
                <icon-line
                  v-if="
                    isActive(actions.SELECTION) ||
                    isActive(actions.LINE) ||
                    typeModule === 'form' ||
                    typeModule === ''
                  "
                />
                <icon-filled-arrow v-if="isActive(actions.FARROW)" />
                <icon-bd-filled-arrow v-if="isActive(actions.BDFARROW)" />
                <icon-dashed-arrow v-if="isActive(actions.DASHEDARROW)" />
                <icon-bd-dashed-arrow v-if="isActive(actions.BDDASHEDARROW)" />
                <icon-arrow v-if="isActive(actions.ARROW)" />
                <icon-bd-arrow v-if="isActive(actions.BDARROW)" />
                <span class="toggle-arrow">
                  <font-awesome-icon
                    class="when-closed"
                    :icon="['fas', 'chevron-down']"
                  />
                  <font-awesome-icon
                    class="when-opened"
                    :icon="['fas', 'chevron-up']"
                  />
                </span>
              </div>
            </b-button>
            <b-collapse
              id="traitChoice"
              class="collapse-menu"
              @show="collapseEl.traitChoice = true"
              @hide="collapseEl.traitChoice = false"
            >
              <div
                class="icon-text-wrap"
                @click.prevent="actionClick(actions.LINE)"
              >
                <icon-line /> Trait
              </div>
              <div
                class="icon-text-wrap"
                @click.prevent="actionClick(actions.FARROW)"
              >
                <icon-filled-arrow /> Flèche
              </div>
              <div
                class="icon-text-wrap"
                @click.prevent="actionClick(actions.BDFARROW)"
              >
                <icon-bd-filled-arrow /> Double flèche
              </div>
              <div
                class="icon-text-wrap"
                @click.prevent="actionClick(actions.DASHEDARROW)"
              >
                <icon-dashed-arrow />Flèche pointillé
              </div>
              <div
                class="icon-text-wrap"
                @click.prevent="actionClick(actions.BDDASHEDARROW)"
              >
                <icon-bd-dashed-arrow /> Double flèche pointillé
              </div>
              <div
                class="icon-text-wrap"
                @click.prevent="actionClick(actions.ARROW)"
              >
                <icon-arrow /> Forme flèche
              </div>
              <div
                class="icon-text-wrap"
                @click.prevent="actionClick(actions.BDARROW)"
              >
                <icon-bd-arrow /> Forme Double flèche
              </div>
            </b-collapse>
          </div>
          <!-- ./trait-menu -->
          <!-- forme-menu -->
          <div class="btn-toolbar" style="margin: 0 5px">
            <div class="btn-group btn-group-xs" role="group">
              <button
                class="btn btn-outline-primary btn-xs"
                @click.prevent="actionClick(actions.RECT)"
              >
                <font-awesome-icon :icon="['far', 'square']" size="lg" />
              </button>
              <button
                class="btn btn-outline-primary"
                @click.prevent="actionClick(actions.CIRCLE)"
              >
                <font-awesome-icon :icon="['far', 'circle']" size="lg" />
              </button>
            </div>
            <button
              class="btn btn-outline-primary"
              @click.prevent="actionClick(actions.EYE)"
            >
              <icon-eye />
            </button>
          </div>
          <div class="btn-toolbar" style="margin: 0 5px">
            <button
              class="btn btn-outline-primary"
              @click.prevent="actionClick(actions.TEXT)"
            >
              <icon-base :width="20" :height="20" iconName="text" />
            </button>
          </div>
          <!-- ./forme-menu -->
          <!-- remplissage-menu -->
          <div class="remplissage-menu menu-cta-item">
            <b-dropdown
              style="width: 45px"
              class="icon-btn addon-btn"
              split
              split-variant="outline-primary"
              variant="primary"
              size="sm"
              id="fill-color"
              @click="collapse()"
              @toggle="collapse()"
              @hide="collapseEl.fillChoice = false"
              @show="collapseEl.fillChoice = true"
              :disabled="
                !this.selectionData.hasSelection ||
                ['layer', 'text', 'customText'].includes(
                  this.selectionData.currentType
                )
              "
            >
              <template slot="button-content">
                <!--                    <div class="tool-color" :style="{ backgroundColor: this.selectionData.currentStyle ? this.selectionData.currentStyle.fill : '#FFFFFF' }"></div>-->
                <font-awesome-icon
                  class="myBgColor"
                  :style="{
                    '--bgImage': this.selectionData.currentStyle
                      ? this.selectionData.currentStyle.fill
                      : '#2b3085',
                  }"
                  :icon="['fas', 'fill-drip']"
                />
              </template>
              <div class="color-picker">
                <color-picker
                  theme="light"
                  v-if="collapseEl.fillChoice"
                  :color="
                    this.selectionData.currentStyle
                      ? selectionData.currentStyle.fill
                      : '#FFFFFF'
                  "
                  :sucker-hide="true"
                  :colors-default="societyColors"
                  :colors-history-key="fillHistoryKey"
                  @changeColor="changeFillColor"
                />
              </div>
            </b-dropdown>
          </div>
          <!-- remplissage-menu -->
          <!-- bordure-menu -->
          <div class="bordure-menu menu-cta-item">
            <b-button
              variant="outline-primary"
              class="icon-btn collapsed addon-btn"
              @click="collapse('bordureChoice')"
              :disabled="
                !this.selectionData.hasSelection ||
                ['layer', 'text', 'customText'].includes(
                  this.selectionData.currentType
                )
              "
            >
              <div class="icon-wrapper">
                <icon-base
                  style="margin-bottom: 0"
                  icon-name="line-weight"
                  :width="18"
                  :height="18"
                />
                <span class="toggle-arrow">
                  <font-awesome-icon
                    class="when-closed"
                    :icon="['fas', 'chevron-down']"
                  />
                  <font-awesome-icon
                    class="when-opened"
                    :icon="['fas', 'chevron-up']"
                  />
                </span>
              </div>
            </b-button>
            <b-collapse
              id="bordureChoice"
              class="collapse-menu"
              @hide="collapseEl.bordureChoice = false"
              @show="collapseEl.bordureChoice = true"
            >
              <div class="tool-body">
                <table>
                  <tr>
                    <td>Epaisseur</td>
                    <td>
                      <b-dropdown
                        style="width: 59px"
                        split
                        split-variant="outline-primary"
                        variant="primary"
                        :text="this.selectedSize + ''"
                        size="sm"
                      >
                        <b-dropdown-item @click="selectStrokeSize(1 / 4)"
                          >1/4</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(1 / 2)"
                          >1/2</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(3 / 4)"
                          >3/4</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(1)"
                          >1</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(1.5)"
                          >1.5</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(2)"
                          >2</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(3)"
                          >3</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(4.5)"
                          >4.5</b-dropdown-item
                        >
                        <b-dropdown-item @click="selectStrokeSize(6)"
                          >6</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td>Couleur</td>
                    <td>
                      <b-dropdown
                        style="width: 59px"
                        class="icon-btn"
                        split
                        split-variant="outline-primary"
                        variant="primary"
                        size="sm"
                        id="stroke-history"
                        @hide="showStrokeColorPicker = false"
                        @show="showStrokeColorPicker = true"
                      >
                        <template slot="button-content">
                          <div
                            class="tool-color"
                            :style="{
                              backgroundColor: selectionData.currentStyle
                                ? selectionData.currentStyle.stroke
                                : '#FFFFFF',
                            }"
                          ></div>
                        </template>
                        <div class="color-picker">
                          <color-picker
                            theme="light"
                            v-if="showStrokeColorPicker"
                            :color="
                              selectionData.currentStyle
                                ? selectionData.currentStyle.stroke
                                : '#FFFFFF'
                            "
                            :sucker-hide="true"
                            :colors-default="societyColors"
                            :colors-history-key="strokeHistoryKey"
                            @changeColor="changeStrokeColor"
                          />
                        </div>
                      </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td>Ligne</td>
                    <td>
                      <lineTypeUI
                        class="d-block mx-2"
                        :lineType="
                          selectionData.currentStyle
                            ? selectionData.currentStyle.dash
                            : []
                        "
                        @change="handleChangeLineType"
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </b-collapse>
          </div>
          <!-- ./bordure-menu -->
          <!-- opacity-menu -->
          <div class="opacity-menu">
            <b-button
              variant="outline-primary"
              class="icon-btn collapsed addon-btn"
              @click="collapse('opacityChoice')"
              :disabled="
                !this.selectionData.hasSelection ||
                ['text', 'customText'].includes(this.selectionData.currentType)
              "
            >
              <div class="icon-wrapper">
                <opacityUI
                  :opacity="this.selectionData.opacity"
                  @change="changeOpacity"
                />
              </div>
            </b-button>
            <!--                <b-collapse id="opacityChoice" class="collapse-menu" @hide="collapseEl.opacityChoice = false" @show="collapseEl.opacityChoice = true">-->
            <!--                  <div class="wrap-zone">-->

            <!--                  </div>-->
            <!--                </b-collapse>-->
          </div>
          <!-- ./opacity-menu -->
        </div>
        <!-- .wrap-group-action -->
        <div class="wrap-group-action police-menu">
          <div
            v-if="
              this.selectionData.hasSelection &&
              ['text', 'customText'].includes(this.selectionData.currentType)
            "
            key="action-activated"
            class="btn-toolbar"
          >
            <fontStyleUI
              :isBold="selectionData.fontStyle.split(' ').indexOf('bold') > -1"
              :isItalic="
                selectionData.fontStyle.split(' ').indexOf('italic') > -1
              "
              @change="handleChange"
              class="menu-cta-item"
            />
            <fontColorUI
              :fontColor="selectionData.currentStyle.fill"
              :colorHistoryKey="fontStory"
              :colors-default="societyColors"
              @change="handleChange"
              class="menu-cta-item"
            />
            <fontFamilyUI
              :fontValue="selectionData.fontFamily"
              @change="handleChange"
              class="menu-cta-item"
            />
            <fontSizeUI
              :fontSize="selectionData.fontSize + ''"
              @change="handleChange"
              class="menu-cta-item"
            />
            <b-form-checkbox
              title="Afficher/Masquer le titre de la données"
              class="show-type-donne"
              v-model="selectionData.showTitle"
              name="check-button"
              @change="
                (checked) => handleChange(ActionType.SHOW_TITLE, checked)
              "
              >{{ selectionData.showTitle ? "Masquer" : "Afficher" }} le titre
              de la données
            </b-form-checkbox>
          </div>
          <div v-else key="action-deactivated" class="btn-toolbar">
            <fontStyleUI :disabled="true" class="menu-cta-item" />
            <fontColorUI :disabled="true" class="menu-cta-item" />
            <fontFamilyUI :disabled="true" class="menu-cta-item" />
            <fontSizeUI :disabled="true" class="menu-cta-item" />
            <b-form-checkbox
              title="Afficher le titre de la données"
              class="show-type-donne"
              name="check-button"
              :disabled="true"
              >Afficher le titre de la données</b-form-checkbox
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { EventBus, events } from "../../eventBus";
import { mapGetters, mapActions } from "vuex";
import iconShema from "../icons/schema";
import iconBase from "../icons/iconBase";
import colorPicker from "@caohenghu/vue-colorpicker";
import inputUI from "./ui";
import { actions, schemaEvents } from "./helper";
import zoom from "./zoom";
import vClickOutside from "v-click-outside";
import { ActionType } from "./ui/actionType";
import axios from "axios";
import { ENTRYPOINT } from "../../config/entrypoint";

let clearTimeoutManager = null;

export default {
  props: {
    schema: {
      type: Object,
      required: true,
    },
  },
  components: {
    ...iconShema,
    iconBase,
    colorPicker,
    ...inputUI,
    zoom,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  async created() {
    const userColors = await axios({
      url: ENTRYPOINT + "/api/get-user-color-history",
      method: "GET",
    });

    this.societyColors = userColors.data.societyColors;
    localStorage.setItem(
      this.fillHistoryKey,
      JSON.stringify(userColors.data.fill)
    );
    localStorage.setItem(
      this.strokeHistoryKey,
      JSON.stringify(userColors.data.stroke)
    );
    localStorage.setItem(
      this.fontStory,
      JSON.stringify(userColors.data.schemaFont)
    );

    this.fillColorHistory = userColors.data.fill;
    this.strokeHistory = userColors.data.stroke;
    this.schemaFontHistory = userColors.data.schemaFont;
  },
  data() {
    return {
      societyColors: [],
      fillColorHistory: [],
      strokeHistory: [],
      schemaFontHistory: [],
      showStrokeColorPicker: false,
      selectedSize: 2,
      selectionData: {
        hasSelection: false,
      },
      selectedShape: null,
      actions,
      ActionType,
      selected: actions.SELECTION,
      collapseEl: {
        fillChoice: false,
        formChoice: false,
        traitChoice: false,
        opacityChoice: false,
        bordureChoice: false,
      },
      typeModule: "",
      usedFillColor: null,
      usedStrokeColor: null,
      fillHistoryKey: "fill-history",
      strokeHistoryKey: "stroke-history",
      fontStory: "font-history",
    };
  },
  computed: {
    ...mapGetters(["currentSelection", "action"]),
    getSelectionData() {
      return this.schema.selectionData;
    },
  },
  mounted() {
    var $this = this;
    this.$root.$on("bv::dropdown::hidden", function (bvEvent) {
      var color, payload;
      if (bvEvent.id === "fill-color") {
        color = $this.usedFillColor;
        payload = {
          color: color,
          type: "fill",
        };

        $this.setUserColor(payload);
      } else if (bvEvent.id === "stroke-history") {
        color = $this.usedStrokeColor;
        payload = {
          color: color,
          type: "stroke",
        };

        $this.setUserColor(payload);
      }
    });

    this.$root.$on("bv::dropdown::show", function (bvEvent) {
      const storeColors = $this.$store.state.colors.colors
      const newSocietyColors = [...new Set([...storeColors, ...$this.societyColors])]

      $this.societyColors = newSocietyColors

      $this.selectedShape = $this.schema.selection;

      if (bvEvent.vueTarget.id === "fill-color") {
        if ($this.usedFillColor === null) {
          localStorage.setItem(
            "fill-history",
            JSON.stringify($this.fillColorHistory)
          );
        }
      } else if (bvEvent.vueTarget.id === "stroke-history") {
        if ($this.usedStrokeColor === null) {
          localStorage.setItem(
            "stroke-history",
            JSON.stringify($this.strokeHistory)
          );
        }
      }
    });
  },
  watch: {
    action(val) {
      this.selected = val;
      if (this.collapseEl.formChoice === true) {
        this.$root.$emit("bv::toggle::collapse", "formChoice");
      }

      if (this.collapseEl.traitChoice === true) {
        this.$root.$emit("bv::toggle::collapse", "traitChoice");
      }
    },
    /* currentSelection (val) {
      if (val.hasSelection) {
        this.selectedSize = val.currentStyle.strokeWidth
        this.selectionData = val
      }
    }, */
    getSelectionData(val) {
      this.selectionData = val;
      if (val.hasSelection) {
        if (val.currentType !== "layer") {
          this.selectedSize = val.currentStyle.strokeWidth;
        }
      }
    },
  },
  methods: {
    ...mapGetters(["saving"]),
    ...mapActions(["setAction"]),
    undo() {
      EventBus.$emit(schemaEvents.ON_UNDO);
    },
    redo() {
      EventBus.$emit(schemaEvents.ON_REDO);
    },
    onEmit(eventName, data, callback) {
      clearTimeout(clearTimeoutManager);
      clearTimeoutManager = setTimeout(() => {
        EventBus.$emit(eventName, data);
        if (callback) callback();
      }, 100);
    },
    actionClick(action) {
      this.typeModule = "";
      if (["rect", "circle", "eye", "text"].includes(action)) {
        this.typeModule = "form";
      }

      if (
        [
          "filledArrow",
          "bidirectionalFilledArrow",
          "dashedArrow",
          "bidirectionalDashedArrow",
          "line",
          "arrow",
          "bidirectionalArrow",
        ].includes(action)
      ) {
        this.typeModule = "trait";
      }
      this.setAction(action);
    },
    async setUserColor(payload) {
      if (payload.color) {
        const resp = await axios({
          url: ENTRYPOINT + "/api/set-user-color",
          data: payload,
          method: "POST",
        });

        this.fillColorHistory = resp.data.fill;
        this.strokeHistory = resp.data.stroke;
        this.schemaFontHistory = resp.data.schemaFont;
      }
      this.onEmit(
        schemaEvents.ON_STYLE_CHANGED,
        {
          selection: this.selectedShape,
        },
        () => (this.selectedShape = null)
      );
    },
    isActive(action) {
      return this.selected === action;
    },
    handleExport() {
      EventBus.$emit(events.SHEMA_EXPORT);
    },
    saveChanges() {
      EventBus.$emit(events.SHEMA_SAVE);
    },
    changeOpacity(value) {
      window.opacity = value;
      this.schema.setOpacity(value);
      this.onEmit(schemaEvents.ON_STYLE_CHANGED, this.schema);
    },
    handleZoom(scale) {
      const { width, height } = Vue.prototype.$stage;
      const nWidth = width * scale;
      const nHeight = height * scale;
      this.schema.stage.width(nWidth);
      this.schema.stage.height(nHeight);
      this.schema.stage.scaleX(scale);
      this.schema.stage.scaleY(scale);
      this.schema.stage.draw();
    },
    selectStrokeSize(value) {
      window.strokeSize = value;
      this.selectedSize = value;
      this.schema.setStyle("STROKE_SIZE", value);
      EventBus.$emit(schemaEvents.ON_STYLE_CHANGED, this.schema);
    },
    changeStrokeColor(color) {
      window.strokeColor = this.toRgbaString(color);
      this.usedStrokeColor = this.toRgbaString(color);
      this.schema.setStyle("STROKE_COLOR", this.toRgbaString(color));
      EventBus.$emit(schemaEvents.ON_STYLE_CHANGED, this.schema);
    },
    toRgbaString(color) {
      const { r, g, b, a } = color.rgba;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    handleChangeLineType(dasharray, linecap) {
      window.lineType = [dasharray, linecap];
      this.schema.setStyle("LINE_TYPE", dasharray, linecap);
      EventBus.$emit(schemaEvents.ON_STYLE_CHANGED, this.schema);
    },
    changeFillColor(color) {
      window.fillColor = this.toRgbaString(color);
      this.usedFillColor = this.toRgbaString(color);
      this.schema.setStyle("SHAPE_FILL", this.toRgbaString(color));
    },
    handleChange(type, value) {
      this.schema.setTextStyle(type, value);
    },
    handleClickOutside() {
      this.collapse();
    },
    collapse(type) {
      if (!type) {
        let shouldClose;
        Object.keys(this.collapseEl).some((key) => {
          if (this.collapseEl[key]) {
            this.collapseEl[key] = false;
            shouldClose = key;
            return true;
          }
          return false;
        });
        if (shouldClose) {
          this.$root.$emit("bv::toggle::collapse", shouldClose);
        }
      } else {
        let prevOpen, newOpen;
        Object.keys(this.collapseEl).forEach((key) => {
          if (this.collapseEl[key]) {
            prevOpen = key;
            this.collapseEl[key] = false;
            return;
          }
          if (key === type) {
            this.collapseEl[key] = true;
            newOpen = key;
          } else {
            this.collapseEl[key] = false;
          }
        });
        if (prevOpen) {
          this.$root.$emit("bv::toggle::collapse", prevOpen);
        }
        this.$root.$emit("bv::toggle::collapse", newOpen);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.zoom-menu,
.opacity-menu {
  .b-dropdown-text {
    margin-bottom: 0;
  }
  .wrap-zone {
    padding: 0 10px;
  }
  .control-zoom {
    display: flex;
    align-items: center;
    span {
      padding-left: 15px;
      padding-right: 15px;
      font-size: 12px;
      color: #2b3085;
      line-height: 12px;
    }
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid #2b3085;
    height: 8px;
    width: 8px;
    border-radius: 50%x;
    background: #2b3085;
    cursor: pointer;
    margin-top: 0;
    box-shadow: none;
  }
}

.action-bar {
  position: relative;
  flex: 0 0 auto;
  // border: 1px solid rgba($color: #000000, $alpha: 0.15);
  // box-shadow: 1px 1px 2px 0px rgba(173,173,173,0.7);
  .btn-toolbar {
    .btn-group {
      margin-right: 10px;
    }
  }
}

#trait {
  .icon-text-wrap {
    font-size: 12px;
    color: #2b3085;
    display: flex;
  }
}

.collapse-menu {
  position: absolute;
  margin-top: 3px;
  z-index: 150;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid #2b3085;
  padding: 5px 0;
}
.toolbox-linear {
  padding-left: 50px;
}
</style>

<style lang="scss">
.wrap-group-action {
  display: flex;
  .menu-cta-item {
    button {
      border-radius: 0;
      &.addon-btn {
        padding-right: 20px;
      }
    }
    &:first-child {
      button {
        border-radius: 3px 0px 0px 3px;
      }
    }
    &:last-child {
      button {
        border-radius: 0px 3px 3px 0px;
        border-right: 1px solid #2b3085;
      }
    }
  }
}
.zoom-menu {
  .dropdown-menu {
    width: 210px;
    padding-bottom: 0;
    box-shadow: none !important;
    border: 1px solid #2b3085;
    margin-top: 4px;
  }
}
.opacity-menu {
  .collapse-menu {
    width: 210px;
    padding-bottom: 0;
  }
}

button.btn-round {
  border: 1px solid #2b3085 !important;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  padding: 0;
  border-radius: 50% !important;
  color: #2b3085;
  font-size: 9px;
  display: flex;
  justify-content: center;
  box-shadow: none !important;
  background-color: #fff !important;
}

.trait-menu,
.forme-menu,
.bordure-menu,
.opacity-menu,
.remplissage-menu {
  .tool-color {
    width: 14px;
    height: 14px;
    border: 1px solid black;
    margin-right: 0;
  }
  .icon-btn {
    height: 25px;
    line-height: 25px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 12px;
    box-shadow: none !important;
    padding-left: 5px;
    position: relative;
    &.collapsed {
      .when-opened {
        display: none;
      }
    }
    &:not(.collapsed) {
      .when-closed {
        display: none;
      }
    }
    .img-icon {
      width: 14px;
      margin-top: -3px;
    }
  }
  .icon-wrapper {
    svg {
      transform: scale(0.6);
      margin-top: -4px;
    }
    .toggle-arrow {
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
    }
  }
}

.forme-menu,
.bordure-menu {
  .icon-wrapper {
    svg {
      transform: scale(1);
      margin-top: -4px;
    }
    .toggle-arrow {
      svg {
        transform: scale(0.6);
      }
    }
  }
}

.bordure-menu {
  .icon-wrapper {
    svg {
      transform: scale(1);
      margin-top: 2px;
    }
  }
}

.collapse-menu {
  .icon-text-wrap {
    display: flex;
    cursor: pointer;
    font-size: 12px;
    align-items: center;
    height: 25px;
    padding-left: 5px;
    padding-right: 5px;
    svg {
      color: #2b3085;
    }
    &.eye-icon {
      svg {
        fill: #2b3085;
        margin-right: 5px;
      }
    }
    &.text-icon {
      svg {
        position: relative;
        left: -3px;
        top: -3px;
      }
    }
    .svg-inline--fa {
      margin-right: 5px;
    }
    &:hover {
      background-color: #2b3085;
      color: #fff;
      svg {
        color: #fff;
        fill: #fff;
      }
    }
  }
}

#traitChoice {
  .icon-text-wrap {
    svg {
      transform: scale(0.6);
      color: #2b3085;
    }
    &:hover {
      background-color: #2b3085;
      color: #fff;
      svg {
        color: #fff;
      }
    }
  }
}

#bordureChoice {
  font-size: 12px;
  color: #2b3085;
  table {
    tr {
      td {
        padding: 5px;
      }
    }
  }
  .b-dropdown {
    padding-left: 0;
    margin: 0 !important;
    .btn {
      background-color: transparent !important;
      color: #2b3085;
      font-size: 12px;
      height: 25px;
      line-height: 25px;
      padding-top: 0;
      padding-bottom: 0;
      box-shadow: none !important;
      &:first-child {
        border-right: none;
        border-radius: 3px 0px 0px 3px;
      }
      &:nth-child(2) {
        border-left: none;
        border-right: 1px solid #2b3085;
        border-radius: 0px 3px 3px 0px;
      }
    }
    .dropdown-menu {
      border-color: #2b3085;
      font-size: 12px;
      a {
        color: #2b3085;
        &:hover {
          color: #fff;
          background-color: #2b3085;
        }
      }
    }
  }
  .color-picker {
    box-sizing: content-box;
    .hu-color-picker {
      box-sizing: content-box;
    }
  }
}

.show-type-donne {
  padding-left: 5px;
  padding-right: 5px;
  input {
    z-index: 1;
    opacity: 0;
  }
  label {
    font-size: 12px;
    color: #fff;
    background: #2b3085;
    border-radius: 3px;
    padding: 0 5px;
    margin-top: 4px;
    cursor: pointer;
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }
  .custom-control-input[disabled] ~ .custom-control-label {
    background: rgba(43, 48, 133, 0.2);
  }
}

.action-bar {
  .police-menu {
    margin-left: 10px;
    border: 1px solid #2b3085;
    border-radius: 3px;
    .btn-toolbar {
      .menu-cta-item {
        margin-right: 0;
        .btn {
          margin: 0 !important;
          font-size: 12px;
          line-height: 25px;
          height: 25px;
          padding-top: 0;
          padding-bottom: 0;
          border: none !important;
          padding-left: 7px;
          padding-right: 7px;
          border-radius: 0;
          box-shadow: none !important;
        }
        &.font-type {
          .btn {
            text-align: left;
            position: relative;
            &:after {
              right: 10px;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
    .color-picker {
      box-sizing: content-box;
      .hu-color-picker {
        box-sizing: content-box;
      }
    }
  }

  .dropdown-menu {
    padding: 0;
  }
  .remplissage-menu {
    .tool-color {
      top: 1px;
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid black;
      margin-right: 0;
      padding-right: 0;
    }
    .icon-btn {
      padding-left: 0;
      margin-right: 0 !important;

      & > .btn {
        background-color: #fff !important;
        box-shadow: none !important;
        &:first-child {
          padding-right: 0;
        }
      }
      .dropdown-toggle {
        border-left: none;
        &:after {
          color: #2b3085;
        }
      }
      .dropdown-menu {
        box-sizing: content-box;
      }
    }
    .color-picker {
      box-sizing: content-box;
      .hu-color-picker {
        box-sizing: content-box;
      }
    }
  }

  button {
    line-height: 0;
    border-radius: 0;
  }
  .myBgColor path {
    fill: var(--bgImage);
  }

  .opacity-menu .icon-wrapper {
    height: 25px;
    line-height: 3px;
  }
  .opacity-menu > button {
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/actionBar.vue